<div style="position:relative;">
  <button mat-icon-button style="position:absolute;right: 0;top: 0;z-index: 1000" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
  <form novalidate [formGroup]="formgroup" autocomplete="false" style="padding-top: 26px;">
    <h4 style="display: flex;flex-direction: row;" mat-dialog-title>
      <span class="title-green">Pour en savoir plus et être rappelé(e) par un conseiller Groupama</span>
    </h4>
    <div mat-dialog-content>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Saisissez votre email</mat-label>
            <input [errorStateMatcher]="matcher" matInput placeholder="email" formControlName="email" required>
            @if (formgroup.controls['email'].invalid && formgroup.controls['email'].touched) {
              <mat-error>
                La saisie de votre email est obligatoire
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Saisissez votre numéro de téléphone</mat-label>
            <input [errorStateMatcher]="matcher" mask="00 00 00 00 00" matInput placeholder="telephone"
                   formControlName="telephone"
                   required>
            @if (formgroup.controls['telephone'].invalid && formgroup.controls['telephone'].touched) {
              <mat-error>
                La saisie de votre téléphone est obligatoire ou le format saisi est incorrect (format (06/07) XX XX XX XX)
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 checkboxAcceptCall">
          <mat-checkbox formControlName="rappel">
            En cochant cette case, j'accepte d'être rappelé(e) et de recevoir par email des informations sur Mon Bilan
            Prévoyance.
          </mat-checkbox>
        </div>
      </div>

      <ng-container *ngrxLet="selectLoadingSaveBilans$; let spinner">
        @if (spinner  | spinnerIsStarted) {
          <div class="row">
            <mat-progress-bar title="Traitement en cours..." mode="indeterminate"></mat-progress-bar>
          </div>
        }
      </ng-container>
    </div>
    <div style="width: 95%; display: flex; ">
      <div class="loading">
        <mat-progress-bar title="Traitement en cours..." mode="indeterminate"></mat-progress-bar>
      </div>
    </div>

    <div style="display: flex;flex-direction: row;justify-content: center;">
      <button mat-raised-button color="accent" (click)="next()" [disabled]="formgroup.invalid">
        ENVOYER
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    <div class="mentionLegal">
      <small>
        Vos données personnelles sont traitées dans le respect de la réglementation en vigueur, vous pouvez
        consulter notre Politique de protection des données, retrouver les informations relatives aux
        traitements mis en œuvre et aux modalités d’exercice de vos droits sur notre site internet groupama.fr
        rubrique « Données personnelles ».
      </small>
    </div>
  </form>
</div>
